import { type CoreItemCategory } from '@flecto/types'
import { useModal } from '@flecto/ui'

import { ModalCategoryUpdate } from '../components/ModalCategoryUpdate/ModalCategoryUpdate'

type UseModalCategoryUpdateProps = {
  category?: Partial<CoreItemCategory>
  onSuccess?: (newCategory: CoreItemCategory) => void
}

export function useModalCategoryUpdate() {
  return useModal<UseModalCategoryUpdateProps>({
    modalComponent: (props) => (
      <ModalCategoryUpdate
        category={props?.category}
        onSuccess={props?.onSuccess}
      />
    ),
  })
}
